import React, { useState, useMemo } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Tooltip,
    Stack,
} from '@mui/material';

import ReactTablePdfDownload from 'src/shared/components/table/components/ReactTablePdfDownload';

const OrderPerformanceReport = ({ isReport }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const excludedColumns = ['hubId', 'customerId'];
    const columns = useMemo(() => (Array.isArray(isReport) && isReport.length > 0 ? Object.keys(isReport[0]) : []), [isReport]);
    const formatColumnName = (name) => name.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
    const replaceColons = (column, value) => {
        const columnsToReplace = ['shiftName', 'riderName', 'hubName'];
        return columnsToReplace.includes(column) && typeof value === 'string' ? value.replace(/:/g, ' ') : value;
    };

    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Remove excluded columns from the isReport data
    const filteredReport = useMemo(() => {
        if (!Array.isArray(isReport)) return [];
        return isReport.map(row => {
            return Object.keys(row || {})
                .filter(column => !excludedColumns.includes(column))
                .reduce((obj, key) => {
                    obj[key] = row[key];
                    return obj;
                }, {});
        });
    }, [isReport, excludedColumns]);

    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" gutterBottom>
                ORDER PERFORMANCE REPORT
            </Typography>
            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
                {/* <ExportXLSX csvData={filteredReport} fileName={"OrderSummaryReport"} title="PICK N DROPORDER SUMMARY REPORT "/> */}
                <ReactTablePdfDownload csvData={filteredReport} fileName="Order_Summary_Report" title="ORDER PERFORMANCE REPORT" portrait="portrait" />
            </Stack>

            <TableContainer component={Paper} sx={{ maxHeight: '800px', overflowY: 'auto' }}>
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ backgroundColor: 'rgb(50 202 115)', color: 'white', fontWeight: 'bold', width: '50px' }}>S.No</TableCell>
                            {Array.isArray(columns) && columns.filter(column => !excludedColumns.includes(column)).map((column) => (
                                <TableCell key={column} sx={{ backgroundColor: 'rgb(50 202 115)', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', width: '150px' }}>
                                    {formatColumnName(column)}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.isArray(filteredReport) && filteredReport.slice(startIndex, endIndex).map((row, index) => (
                            <TableRow key={index} sx={{ backgroundColor: (index % 2 === 0) ? 'transparent' : '#f5f5f5' }}>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>{startIndex + index + 1}</TableCell>
                                {Array.isArray(columns) && columns.filter(column => !excludedColumns.includes(column)).map((column) => {
                                    const cellValue = row ? row[column] : "";
                                    const displayValue = (cellValue === ':') ? '' : replaceColons(column, cellValue);
                                    return (
                                        <TableCell key={column} sx={{ whiteSpace: 'nowrap', overflow: 'visible', maxWidth: 'none' }}>
                                            <Tooltip title={String(cellValue || "")} arrow>
                                                <span>{displayValue}</span>
                                            </Tooltip>
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={filteredReport.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Box>
    );
};

export default OrderPerformanceReport;
